import Slider from "react-slick";
import { Container, Row, Col } from "react-bootstrap";
import './carousel.css'

const rxnt = "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/carousel/rxnt.svg"
const frank = "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/carousel/frank.svg"
const thomson = "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/carousel/thomson.svg"
const anatomie = "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/carousel/anatomie.svg"
const svhs = "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/carousel/svhs.svg"
const asn = "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/carousel/asn.svg"
const openn = "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/carousel/openn.svg"
const hopscotch = "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/carousel/hopscotch.svg"
const hatem = "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/carousel/hatem.svg"
const interplai = "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/carousel/interplai.svg"
const mobi = "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/carousel/mobi.svg"
const myOutcomes = "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/carousel/my-outcomes.svg"
const vacSewCenter = "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/carousel/vacsew-center.svg"
const tds = "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/carousel/tds-logo.svg"
const westBoca = "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/carousel/west-boca.svg"
const tynax = "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/carousel/tynax.svg"

const BrandsCarousel = () => {
    const brandsCarouselSettings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 5,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
        arrows: false,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: false
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            }
        ]
    };

    return (
        <section className="brands-carousel-wrapper py-4">
            <Container fluid>
                <Row>
                    <Col xs='12'>
                        <div className="text-center mb-4">
                            <h2 className="ft-wt-700 text-uppercase text-primary">Businesses We Have Scaled</h2>
                        </div>
                    </Col>
                    <Col xs="12">
                        <Slider {...brandsCarouselSettings} className="brands-carousel">
                            <div>
                                <img src={rxnt} alt="rxnt" loading="lazy" />
                            </div>
                            <div>
                                <img src={frank} alt="frank" loading="lazy" />
                            </div>
                            <div>
                                <img src={thomson} alt="thomson" loading="lazy" />
                            </div>
                            <div>
                                <img src={anatomie} alt="anatomie" loading="lazy" />
                            </div>
                            <div>
                                <img src={svhs} alt="svhs" loading="lazy" />
                            </div>
                            <div>
                                <img src={asn} alt="asn" loading="lazy" />
                            </div>

                            <div>
                                <img src={openn} alt="openn" loading="lazy" />
                            </div>
                            <div>
                                <img src={hopscotch} alt="hopscotch" loading="lazy" />
                            </div>
                            <div>
                                <img src={hatem} alt="hatem" loading="lazy" />
                            </div>
                            <div>
                                <img src={interplai} alt="interplai" loading="lazy" />
                            </div>
                            <div>
                                <img src={tds} alt="svhs" loading="lazy" />
                            </div>
                            <div>
                                <img src={myOutcomes} alt="myOutcomes" loading="lazy" />
                            </div>
                            <div>
                                <img src={mobi} alt="mobi" loading="lazy" />
                            </div>
                            <div>
                                <img src={westBoca} alt="westBoca" loading="lazy" />
                            </div>
                            <div>
                                <img src={vacSewCenter} alt="vacSewCenter" loading="lazy" />
                            </div>
                            <div>
                                <img src={tynax} alt="tynax" loading="lazy" />
                            </div>
                        </Slider>
                    </Col>
                </Row>
            </Container>
        </section>
    );
};

export default BrandsCarousel;
